import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import styles from "./style.module.css";
const Tooltip = ({ trigger, placement, rootClose, overlay, title, children, tooltipIconStyleOverride, ...retProps }) => {
    const retPlacement = placement ?? "top";
    let retOverlay = overlay;
    if (typeof overlay === "string") {
        retOverlay = React.createElement("div", { className: styles.tooltipOverlay }, overlay);
    }
    return (React.createElement(OverlayTrigger, { placement: placement ?? "top", trigger: trigger ?? ["hover", "click"], rootClose: rootClose !== undefined ? rootClose : true, overlay: React.createElement(Popover, { id: `popover-positioned-${retPlacement}`, title: title }, retOverlay), ...retProps }, children ? (children) : (React.createElement("div", { className: styles.tooltipIcon, style: tooltipIconStyleOverride },
        React.createElement(FontAwesomeIcon, { icon: faInfo })))));
};
export default Tooltip;
